import classnames from "classnames";
import React from "react";

// tslint:disable-next-line:no-var-requires
const style = require("./BlinkingComponent.scss");

export interface BlinkingComponentProps<T> {
    readonly value: T;
    readonly formatValue: (value: T) => string;
    readonly blinking: boolean;
    readonly className?: string;
}

export default function BlinkingComponent<T>(props: BlinkingComponentProps<T>) {
    const { formatValue, value } = props;
    const className = classnames(
        style.blinkingComponent,
        props.className,
        props.blinking && style.blinking
    );
    return (
        <span className={className}>
            <span>{formatValue(value)}</span>
        </span>
    );
}
